<script setup lang='ts'>
import { sendEmailVerificationCode } from '@/service/api/accountCenter/security'
import { bindingEmail } from '@/service/api/basic'
import { useTrackerStore } from '@/store'
import { useApiStore } from '@/store/api'
import { useFormRules } from '@/utils/form'

const trackerStore = useTrackerStore()

const { formRules } = useFormRules()

const { getMembershipInformationFn } = useApiStore()

const emailModal = ref(false)
const emailFormRef = ref()
const emailForm = reactive({
  email: '',
  emailVerificationCode: '',
})
const emailRule = {
  email: formRules.email,
  emailVerificationCode: {
    required: true,
    trigger: ['input', 'blur'],
    message: '请输入验证码',
  },
}
// 获取邮箱验证码
const sendEmailText = ref('发送验证码')
const sendEmailBtn = ref(false)
async function sendEmailVerificationCodeFn() {
  const val: any = await sendEmailVerificationCode({ email: emailForm.email })
  if (val.code === 1000) {
    window.$message.success('邮箱验证码已发送，请注意查收！')
    sendEmailBtn.value = true
    let time = 60
    const setIntervalFn = setInterval(() => {
      if (time === 0) {
        clearInterval(setIntervalFn)
        sendEmailBtn.value = false
        sendEmailText.value = '发送验证码'
      }
      else {
        sendEmailText.value = `重新获取 ${time}`
        time--
      }
    }, 1000)
  }
}
const reload: any = inject('reload')
// 修改邮箱弹框确认操作
async function emailModalConfirm(e: MouseEvent) {
  e.preventDefault()
  emailFormRef.value?.validate(async (errors: Error) => {
    if (!errors) {
      const res = await bindingEmail(emailForm)
      if (res.code === 1000) {
        window.$message.success('邮箱验证成功')
        emailModal.value = false
        emailForm.email = ''
        emailForm.emailVerificationCode = ''
        reload()
        trackerStore.reportBySpecialDirectives('Button', JSON.stringify(emailForm), { eventOtherContent: '邮箱验证成功' })
      }
    }
  })
}

const isemail = ref(0)
const haveConsumption = ref(null)
onMounted(async () => {
  const res = await getMembershipInformationFn() as User.Membercenter.MemberShipInfo
  if (res.isemail !== 1) {
    isemail.value = res.isemail
    haveConsumption.value = res.haveConsumption
    emailModal.value = true
  }
})
</script>

<template>
  <n-modal v-model:show="emailModal" class="email-modal" :mask-closable="false" :close-on-esc="false" to=".self-content">
    <n-card
      style="width: 600px"
      header-class="!pb-16px"
      title="提示"
      :bordered="false"
      size="huge"
      role="dialog"
      aria-modal="true"
    >
      <div class="mb-16px text-16px">
        <template v-if="isemail === 0">
          尊敬的用户，系统检测到您的邮箱还未验证，为了确保您能及时接收到产品通知，同时保障您的账户安全，请花1分钟时间前往会员中心进行邮箱验证。
        </template>
        <template v-if="isemail === 3">
          尊敬的用户，系统检测到您的邮箱已失效，为了确保您能及时接收到产品通知，同时保障您的账户安全，请花1分钟时间补充完整您的邮箱。
        </template>
        <template v-if="isemail === 2 && haveConsumption === 'y'">
          尊敬的用户，系统检测到您还未填写联系邮箱，为了确保您能及时接收产品通知并保障账户安全，请花1分钟时间前往会员中心维护您的联系邮箱吧~
        </template>
        <template v-if="isemail === 2 && haveConsumption === 'n'">
          您好！我们即将为您带来更优质的产品服务体验。为方便第一时间为您推送专属福利和重要通知，建议您花1分钟时间在会员中心完善联系邮箱。您的信息将受到严格保护，且仅用于提升服务质量的相关通知。
        </template>
      </div>
      <n-form
        ref="emailFormRef"
        :model="emailForm"
        :rules="emailRule"
        label-placement="left"
        :label-width="100"
        label-align="left"
      >
        <div class="line-height-34px">
          <n-form-item label="邮箱" path="email" :label-style="{ color: '#9BA6BF' }">
            <n-input v-model:value="emailForm.email" placeholder="请输入正确的邮箱" />
          </n-form-item>
          <n-form-item label="验证码" path="emailVerificationCode" :label-style="{ color: '#9BA6BF' }">
            <div class="flex-1 flex">
              <n-input v-model:value="emailForm.emailVerificationCode" class="max-w-174px mr-5px" type="text" placeholder="请输入验证码" />
              <n-button color="#1664FF" :disabled="sendEmailBtn" @click="sendEmailVerificationCodeFn">
                {{ sendEmailText }}
              </n-button>
            </div>
          </n-form-item>
        </div>
      </n-form>
      <template #footer>
        <div class="text-center">
          <n-button class="mr-10px" color="#1664FF" @click="emailModalConfirm">
            确定修改
          </n-button>
        </div>
      </template>
    </n-card>
  </n-modal>
</template>

<style lang="scss" scoped>

</style>
